import React from 'react';
import './styles.css';





export const Info = () => {


  return (
    <>


        <div className="Info-Container">
            + Info.
        </div>

        
    </>
  )
}
